import {createElement, getTransitionDuration} from 'methods/utils';
import Layout from 'components/layout';

function ModalLayers() {
    // singleton
    if (window.ModalLayers) {
        return window.ModalLayers;
    }
    window.ModalLayers = this;

    this._modals          = [];
    this._activeModals    = [];
    this._historyIterator = 0;

    this.$element = createElement(
        `<div class="Modal-layers js-modalLayers">
            <div class="Modal-layers__container js-modalLayersContainer">
                <div class="Modal-layers__backdrop js-modalLayersBackdrop"></div>
            </div>
        </div>`
    );

    // элементы
    this.$backdrop = this.$element.querySelector('.js-modalLayersBackdrop');
    this.$container = this.$element.querySelector('.js-modalLayersContainer');

    // события
    this.$backdrop.addEventListener('click', this._onBackdropClickBind = this._onBackdropClick.bind(this));

    // рендер
    document.body.appendChild(this.$element);
}

/**
 * Добавление модалки
 * @param {Modal} modal Объект модалки
 */
ModalLayers.prototype.add = function(modal) {
    this._modals.push(modal);
    this.$container.appendChild(modal.$modal);

    modal.on('before:open', this._onModalOpen.bind(this, modal));
    modal.on('before:close', this._onModalClose.bind(this, modal));
}

/**
 * Закрытие активной модалки.
 *
 * @param {String} initiator Инициатор события
 */
ModalLayers.prototype.closeActiveModal = function(initiator) {
    const modal = this._activeModals.pop();
    if (modal) {
        modal.close(initiator);
    }
    return modal;
}

/**
 * Событие нажатия кнопки на клавиатуре
 * @param {Event} e Событие
 */
ModalLayers.prototype._onKeyPressEvent = function(e) {
    // ESC
    if (e.keyCode == 27) {
        e.preventDefault();
        e.stopPropagation();

        this.closeActiveModal('user');
    }
}

/**
 * Событие открытия модалки
 * @param {Modal} modal Модалка
 */
ModalLayers.prototype._onModalOpen = function(modal) {
    this._activeModals.push(modal);
    this.$element.classList.add('is-active');

    // закрытие активной модалки на ESC
    if (!this._onKeyPressEventBind) {
        window.addEventListener('keydown', this._onKeyPressEventBind = this._onKeyPressEvent.bind(this));
    }

    // закрытие активной модалки на ESC
    if (!this._onKeyPressEventBind) {
        window.addEventListener('keydown', this._onKeyPressEventBind = this._onKeyPressEvent.bind(this));
    }

    // манипуляции с историей браузера
    if (!this._onPopStateEventBind) {
        window.addEventListener('popstate', this._onPopStateEventBind = this._onPopStateEvent.bind(this));
    }

    // манипуляции с историей браузера
    window.history.pushState({
        ModalLayers: {
            historyIterator: ++this._historyIterator,
        },
    }, '');


    if (modal.options.backdrop) {
        this.$container.appendChild(this.$backdrop);
    }

    // двигаем модалку вперёд
    this.$container.appendChild(modal.$modal);

    window.requestAnimationFrame(() => {
        this.$backdrop.classList.add('is-active');
    });

    Layout.scroll.disable();
}

/**
 * Событие закрытия модалки
 * @param {Modal}  modal     Модалка
 * @param {String} initiator Инициатор события
 */
ModalLayers.prototype._onModalClose = function(modal, initiator) {
    const index = this._activeModals.indexOf(modal);
    if (index != -1) {
        this._activeModals.splice(index, 1);
    }

    // иерархия модалок
    if (this._activeModals.length) {
        const activeModal = this._activeModals[this._activeModals.length - 1];
        this.$container.appendChild(this.$backdrop);
        this.$container.appendChild(activeModal.$modal);
        Layout.scroll.enable();
    }

    // предотвращение повторного закрытия модалки
    // т.к. при закрытии модалки через popstate срабатывает этот же метод
    if (initiator != 'history') {
        // TODO: вместо удаления обработчиков лучше сделать на стеке инициаторов, если стек пуст то закрывать в popstate
        window.removeEventListener('popstate', this._onPopStateEventBind);
        window.history.back();

        setTimeout(() => {
            window.addEventListener('popstate', this._onPopStateEventBind);
        }, 10);
    }

    // закрыта последняя модалка
    if (!this._activeModals.length) {
        this.$backdrop.classList.remove('is-active');
        this.$element.classList.remove('is-active');

        setTimeout(() => {
            Layout.scroll.enable();
        }, getTransitionDuration(modal.$modal));

        // манипуляции с историей браузера
        window.removeEventListener('popstate', this._onPopStateEventBind);
        delete this._onPopStateEventBind;

        // закрытие активной модалки на ESC
        window.removeEventListener('keydown', this._onKeyPressEventBind);
        delete this._onKeyPressEventBind;
    }
}

/**
 * Клик по фону
 * @param {Event} e Событие
 */
ModalLayers.prototype._onBackdropClick = function(e) {
    this.closeActiveModal('user');
}

/**
 * Переход в браузере
 * @param {Event} e Событие
 */
ModalLayers.prototype._onPopStateEvent = function(e) {
    const iterator = (e.state && e.state.ModalLayers) ? e.state.ModalLayers.historyIterator : this._historyIterator - 1;
    const steps    = iterator - this._historyIterator;
    const forward  = steps > 0;

    this._historyIterator = iterator;

    if (!forward) {
        for (let i = 0; i < Math.abs(steps); ++i) {
            this.closeActiveModal('history');
        }
    }
}


export default new ModalLayers();
